import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function buildWeekSetter ( buildWk ) {

    const itemBuildWk = formatGivenDate( buildWk, 'YYYY-MM-DD' );

    if ( itemBuildWk === '' ) return ( <span>{itemBuildWk}</span> );
    if ( itemBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( itemBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return itemBuildWk;

}

const colDefs = [
    {
        field: 'model',
        headerName: 'Model',
        sortable: false,
        filter: true,
        width: 100,
        colSpan ( params ) {

            return ( params.data.model === '0' ) ? 3 : 1;

        },
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( params.value === '0' ) {

                return ( <span className="totalMessage">{params.data.message}</span> );

            }
            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'allocatedInd',
        headerName: 'Allocated Ind',
        sortable: true,
        filter: true,
        width: 100
    }
];

class PoolOrdersByPoolPkgCodeTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

        setTimeout( () => {

            this.gridApi.sizeColumnsToFit();

        }, 500 );

    }

    render () {

        return (
            <section className="atp-search-result-panel pool-orders-by-pool-pkg-code-panel ">
                <div className="buildWk"> Build Week: {buildWeekSetter( this.props.buildWeek )} </div>
                <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        columnDefs={colDefs}
                        rowData={this.props.results}
                        onGridReady={this.onGridReady}
                    />
                </div>
            </section>
        );

    }

}

PoolOrdersByPoolPkgCodeTable.propTypes = {
    results: PropTypes.array.isRequired,
    buildWeek: PropTypes.number
};
export default PoolOrdersByPoolPkgCodeTable;
